import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-phone\">\n<rect x=\"5\" y=\"2.5\" width=\"14\" height=\"20\" rx=\"2\" stroke=\"#38CB89\" stroke-width=\"1.5\" />\n<path d=\"M9 2.5H15V3.5C15 4.05228 14.5523 4.5 14 4.5H10C9.44772 4.5 9 4.05228 9 3.5V2.5Z\" fill=\"#38CB89\" />\n<path d=\"M10 19.5H14\" stroke=\"#38CB89\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol